const pdp = {
  init: () => {


    if ($('.pdp-gallery-slider')[0]) {
      $('.pdp-gallery-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        fade: true,
        speed: 120,
        asNavFor: '.pdp-gallery-pager',
        responsive: [{
          breakpoint: 769,
          settings: {
            adaptiveHeight: true,
            dots: false,
            asNavFor: null
          }
        }]
      });

      $('.pdp-gallery-pager').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.pdp-gallery-slider',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        vertical: true
      });
    }

    if ($('.pdp-gallery-slider-merch')[0]) {
      $('.pdp-gallery-slider-merch').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        fade: true,
        speed: 120,
        asNavFor: '.pdp-gallery-pager-merch',
        responsive: [{
          breakpoint: 769,
          settings: {
            adaptiveHeight: true
          }
        }]
      });

      $('.pdp-gallery-pager-merch').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.pdp-gallery-slider-merch',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        vertical: true
      });
    }

    if ($('.pdp-wtd-slider')[0]) {
      $('.pdp-wtd-slider').slick({
        centerMode: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        centerPadding: '0px',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });

      $(document).on('click', '.pdp-wtd-slider-next', function() {
        $('.pdp-wtd-slider').slick('slickNext');
      });

    }

    $('#productSelect').change(function(event) {

      var optionIndex = $('option:selected', this).attr('option-index');
      var optionVariant = $('option:selected', this).attr('prod-variant-id');
      var price = $('option:selected', this).attr('prod-price');
      var subscription_price = $('option:selected', this).attr('prod-subscription-price');
      var img = $('option:selected', this).attr('prod-img');
      var pack = $('option:selected', this).attr('prod-pack');
      var flav = $('option:selected', this).attr('flav-name');
      var flav_name = $('option:selected', this).attr('flav-name-handle');
      var flav_ingrediant = $('option:selected', this).attr('var-ingrediant');
      var variant_desc = $('option:selected', this).attr('prod-variant-description');
      $('.pdp-ingredients-list').hide();
      var activeVariant ='.pdp-ingredients-list.' + flav_name +'-' + flav_ingrediant;
      //console.log(activeVariant);
      $(activeVariant).show();
      $('.buy-box-price').text(price);
      if($('.js-product-price').length>0){
        $('.js-product-price').text(price);
      }
      $('.buy-box-subscription-price').text(subscription_price);
      // $('.pdp-product-img.feature-img').attr('src', img);
      // $('.product-single__thumbnail-image.featured').attr('src', img);
      $('.pdp-buy-box-denomination span').text(pack);
      $('.dynamic-variant-name').text(flav);

      // Update variant description
      $('.pdp-short-description').text(variant_desc);

      // Hide subscription and quantity from "sampler" variants
      if (flav_name === "greatest-hits-sampler-pack" || flav_name === "sampler-pack") {
        //console.log("is sampler: " + flav_name);
        $('.subscription-container').addClass("hidden");
        $('.rtx_option--sub').addClass("hidden");
        $('.pdp-qty-selector').addClass("hidden");
        $("#Quantity").attr("disabled", true).val(1);
      } else {
        //console.log("not sampler: " + flav_name);
        $('.subscription-container').removeClass("hidden");
        $('.rtx_option--sub').removeClass("hidden");
        $('.pdp-qty-selector').removeClass("hidden");
        $("#Quantity").attr("disabled", false);
      };

      refreshFilteredGalleries();

    });

    function refreshFilteredGalleries() {

      //console.log("Refreshing filtered galleries...");

      var optionIndex = $('option:selected', '#productSelect').attr('option-index');
      var optionVariant = $('option:selected', '#productSelect').attr('prod-variant-id');
        $(".pdp-gallery.is-show").removeClass('is-show');
        $(`.pdp-gallery[data-gallery="${optionVariant}"]`).addClass('is-show');
        //console.log("optionIndex: "+optionVariant);
      //console.log("optionVariant: "+optionVariant);

      var variantClass = '.' + optionVariant;

      //sVariant Specific Image Filtering
      if($('.pdp-gallery-slider').length>0) {
        if (optionIndex == 0) {
          $('.pdp-gallery-slider').slick('slickUnfilter');
          $('.pdp-gallery-slider').slick('slickFilter', '.global');

          $('.pdp-gallery-pager').slick('slickUnfilter');
          $('.pdp-gallery-pager').slick('slickFilter', '.global');
        } else {
          $('.pdp-gallery-slider').slick('slickUnfilter');
          $('.pdp-gallery-slider').slick('slickFilter', variantClass);

          $('.pdp-gallery-pager').slick('slickUnfilter');
          $('.pdp-gallery-pager').slick('slickFilter', variantClass);
        }
      }
      // Nasty issue to track down related to using slickFilter and asNavFor
      // "This will re-align the indices on the slides, and it won’t navigate to wrong slide after filtering."
      // https://www.aakashahmed.com/jquery/slick-filter-not-working-right-on-slick-slider-fixed/
      var $slider = $('.pdp-gallery-pager, .pdp-gallery-slider');
      $slider.each(function(index,slide){
          s_id = 0;
          //console.log(index,slide,s_id);
          $(".slick-slide:not(.slick-cloned)",slide).each(function(s_index,s_slide) {
              $(this).attr("data-slick-index",s_id)
              s_id = s_id+1;
              if (index==0) {
                  if ($(this).hasClass("slick-current")) {
                      active_index = s_id;
                  }
              }
              if (index==1) {
                  if (s_id==active_index) {
                      $(this).addClass("slick-current");
                  } else {
                      $(this).removeClass("slick-current");
                  }
              }
          });
      });

      if($('.pdp-gallery-pager').length>0) {
        $('.pdp-gallery-pager')[0].slick.refresh();
        $('.pdp-gallery-pager').slick('slickGoTo', 0);

        $('.pdp-gallery-slider')[0].slick.refresh();
        $('.pdp-gallery-slider').slick('slickGoTo', 0);
      }

    }

    var merch_check = $("body.suffix-merch");
    if (!merch_check.length) {
      refreshFilteredGalleries();
    }

    waitForElementToDisplay('.pdp-buy-box-extra .yotpo .text-m',function(){

      let review_string = $('.pdp-buy-box-extra .yotpo .text-m').text();
      //console.log(`review_string: ${review_string}`);

      let review_string_mod = review_string.replace(' Reviews',')'); // if "Reviews"
      review_string_mod = review_string_mod.replace(' Review',')'); // if "Review"
      review_string_mod = review_string_mod.replace('Write a review','0)'); // if "Write a review"
      review_string_mod = '(' + review_string_mod;
      //console.log(`review_string_mod: ${review_string_mod}`);

      $('.pdp-buy-box-extra .yotpo .text-m').text(review_string_mod);

    },1000,9000);

    function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
      var startTimeInMs = Date.now();
      (function loopSearch() {
        if (document.querySelector(selector) != null) {
          callback();
          return;
        }
        else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
              return;
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    }


  }
};
export default pdp;
